import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import './App.css';

import { LanguageProvider } from './contexts/LanguageContext';
import SplashScreen from './components/SplashScreen';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function MainApp() {
  return (
    <div style={{ background: '#0A1128', minHeight: '100vh' }}>
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  const [splashDone, setSplashDone] = useState(false);

  return (
    <LanguageProvider>
      <AnimatePresence mode="wait">
        {!splashDone ? (
          <SplashScreen key="splash" onComplete={() => setSplashDone(true)} />
        ) : (
          <MainApp key="main" />
        )}
      </AnimatePresence>
    </LanguageProvider>
  );
}

export default App;
